export default function ThankYou({ auth }) {
  setInterval(() => auth.redirectToLoginAfterLogout(), 3000);

  return <div style={{ color: "white", textAlign: "center", padding: "24px 48px" }}>
    You are being logged out to fetch the latest information about your user account! Please log in again to view option sweeps.
  </div>
}